import React, {Component} from 'react';
import {classNames} from 'primereact/utils';
import {Formik} from 'formik';
import {Toast} from 'primereact/toast';
import {Button} from 'primereact/button';
import {FileUpload} from 'primereact/fileupload';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';
import {I18n} from "react-redux-i18n";
import {Dropdown} from "primereact/dropdown";
import {connect} from "react-redux";
import {
    address,
    email,
    getAddressObject,
    getFormattedPhone,
    getFormErrorMessage, getPhoneLang,
    getPosition,
    isFormFieldInvalid,
    phone
} from "../helpers/utils";
import {InputTextarea} from "primereact/inputtextarea";
import * as Yup from 'yup';
import PhoneInput from "react-phone-input-2";
import GooglePlacesAutocomplete, {geocodeByPlaceId} from 'react-google-places-autocomplete';
import BusinessService from "../services/BusinessService";
import ImageCrop from "./ImageCrop";
import {Permission} from "../helpers/permission";

class ManageBusiness extends Component {
    emptyElement = {
        name: '',
        description: '',
        website: '',
        type: '',
        currencyCode: '',
        logo: null,
        tempLogo: null,
        email,
        phoneNumber: phone,
        address,
    };


    constructor(props) {
        super(props);
        this.formikRef = React.createRef();
        this.formikProps = {
            initialValues: this.emptyElement,
            validationSchema: Yup.object().shape({
                name: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')),
                description: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')),
                website: Yup.string().url(I18n.t('INVALID_URL')),
                email: Yup.object().shape({
                    value: Yup.string().email(I18n.t('INVALID_EMAIL')).nullable()
                }),
                phoneNumber: Yup.object().shape({
                    formattedNumber: Yup.string().required(I18n.t('PHONE_NUMBER_IS_REQUIRED'))
                }),
                currencyCode: Yup.string().required(I18n.t('CURRENCY_CODE_IS_REQUIRED')),
                address: Yup.object().shape({
                    label: Yup.string().required(I18n.t('ADDRESS_IS_REQUIRED'))
                }),
                type: Yup.string().when([], {
                    is: () => this.types.length > 1,
                    then: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')),
                    otherwise: Yup.string().notRequired()
                })
            }),
            onSubmit: (element) => {
                this.saveElement(element)
            },

        };

        this.state = {
            loading: false,
            elementDialog: props.show ?? false,
            element: this.emptyElement,
            loadingDialog: false,
            src: null,
            cropsLogo: {},
            cropsType: 'logo',
            aspect: 1,
            imageSrc: null,
            crop: {x: 0, y: 0},
            zoom: 1
        };

        this.elementService = new BusinessService();
        this.loadTypes = this.loadTypes.bind(this);
        this.saveElement = this.saveElement.bind(this);
        this.renderFooter = this.renderFooter.bind(this);
        this.editElement = this.editElement.bind(this);
        this.hideDialog = this.hideDialog.bind(this);
        this.handleMapAddressChange = this.handleMapAddressChange.bind(this);
        this.cancelPhotoCrop = this.cancelPhotoCrop.bind(this);
        this.onCropComplete = this.onCropComplete.bind(this);
    }

    componentDidMount() {
        this.loadTypes();
        this.loadCurrencies();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.locale !== this.props.locale) {
            this.loadTypes();
            this.loadCurrencies();
        }
        if (prevProps.show !== this.props.show) {
            this.setState({elementDialog: this.props.show});
        }

        if (prevProps.element !== this.props.element) {
            if (this.props.element != null) {
                let element = this.props.element;
                element.tempLogo = element.logo
                element.logo = null
                element.address.value = {place_id: ''}
                this.setState({element: element});
                this.formikProps.initialValues = element;
            }
        }
    }

    loadCurrencies() {
        const currencies = [];
        const list = this.props.settings?.CURRENCIES;
        console.log('list',list)
        if (list && list.length > 0) {
            list.forEach(currency => {
                currencies.push({name: I18n.t(currency + '_DESCRIPTION'), code: currency});
            });
        }
        this.currencies = currencies;
        console.log('currencies',currencies)
    }

    loadTypes() {
        const permissions = this.props.permissions;
        const types = [];

        const hasMerchant = permissions?.includes(Permission.PERMISSION_MERCHANT_MANAGE_BUSINESS);
        const hasBusiness = permissions?.includes(Permission.PERMISSION_DEVELOPER_MANAGE_BUSINESS);

        if (hasMerchant) types.push({name: I18n.t('MERCHANT_DESCRIPTION'), code: 'MERCHANT'},);
        if (hasBusiness) types.push({name: I18n.t('DEVELOPER_DESCRIPTION'), code: 'DEVELOPER'});

        if (hasMerchant && hasBusiness) {
            types.push({name: I18n.t('MERCHANT_DEVELOPER_DESCRIPTION'), code: 'MERCHANT_DEVELOPER'});
        }
        this.types = types;
    }

    hideDialog() {
        this.formikProps.initialValues = this.emptyElement;
        this.setState({
            elementDialog: false,
            element: this.emptyElement
        });
        if (this.props.onComplete) {
            this.props.onComplete({
                data: null
            });
        }
    }

    handleMapAddressChange = (props, initialAddress) => {
        if (initialAddress) {
            let placeId = initialAddress["value"]["place_id"];
            geocodeByPlaceId(placeId)
                .then(results => {
                    if (results[0]) {
                        let address = getAddressObject(results[0].address_components);
                        address.label = initialAddress.label
                        address.value.place_id = initialAddress.value.place_id
                        let position = getPosition(results[0].geometry.location);
                        props.setFieldValue('address', address)
                        props.setFieldValue('position', position)
                    }
                })
                .catch(error => console.error("erreur found " + error));
        }
    }

    saveElement(element) {
        if (!!!element.type && this.types.length === 1) {
            element.type = this.types.pop().code;
        }
        this.setState({
            loadingDialog: true,
        });
        const data = new FormData();
        if (element.logo) {
            data.append("logo", element.logo, element.logo.name);
            element.cropsLogo = this.state.cropsLogo;
        }
        data.append("data", JSON.stringify(element));
        if (element.id) { //may be update
            this.elementService.edit(element.identifier, data)
                .then((response) => {
                    this.setState({
                        elementDialog: false,
                        loadingDialog: false,
                        element: this.emptyElement,
                    });
                    this.formikProps.initialValues = this.emptyElement;
                    if (this.props.onComplete) {
                        this.props.onComplete({
                            update: true,
                            data: response.data.content
                        });
                    }
                    this.toast.show({
                        severity: 'success',
                        summary: I18n.t('UPDATE'),
                        detail: I18n.t('UPDATE_SUCCESSFUL'),
                        life: 6000
                    });
                })
                .catch(error => {
                    this.setState({
                        loadingDialog: false,
                    });
                    this.toast.show({
                        severity: 'error',
                        summary: I18n.t('UPDATE'),
                        detail: I18n.t(error.response.data.code),
                        life: 6000
                    });
                });
        } else { //may be creation
            this.elementService.add(data)
                .then((response) => {
                    this.setState({
                        elementDialog: false,
                        loadingDialog: false,
                        element: this.emptyElement,
                        totalRecords: this.state.totalRecords + 1,
                    });
                    this.formikProps.initialValues = this.emptyElement;
                    if (this.props.onComplete) {
                        this.props.onComplete({
                            update: false,
                            data: response.data.content
                        });
                    }
                    this.toast.show({
                        severity: 'success',
                        summary: I18n.t('ADD'),
                        detail: I18n.t('ADD_SUCCESSFUL'),
                        life: 6000
                    });
                })
                .catch(error => {
                    this.setState({
                        loadingDialog: false,
                    });
                    this.toast.show({
                        severity: 'error',
                        summary: I18n.t('ADD'),
                        detail: I18n.t(error.response.data.code),
                        life: 6000
                    });
                });
        }
    }

    editElement(element) {
        element.tempLogo = element.logo
        element.logo = null
        element.address.value = {place_id: '',}
        this.formikProps.initialValues = element;
        this.setState({
            elementDialog: true
        });
    }

    onCropComplete = (croppedAreaPixels) => {
        let crops;
        if (this.state.cropsType === 'logo') {
            crops = {...this.state.cropsLogo};
        }
        crops[this.file.name] = croppedAreaPixels.x + ',' + croppedAreaPixels.y + ',' + croppedAreaPixels.width + ',' + croppedAreaPixels.height
        if (this.state.cropsType === 'logo') {
            this.setState({cropsLogo: crops});
        }
    };

    cancelPhotoCrop() {
        this.setState({loadingProcessingDialog: true});
        let filesRow = document.getElementsByClassName("p-fileupload-row");
        let targetRow;
        for (let i = 0; i < filesRow.length; i++) {
            let element = filesRow[i];
            for (let i = 0; i < element.childNodes.length; i++) {
                let child = element.childNodes[i];
                if (child.textContent === this.file.name) {
                    targetRow = element;
                }
            }
        }
        let button = targetRow.getElementsByTagName('button')[0]
        button.click()
        this.setState({elementPhotoDialog: false, loadingProcessingDialog: false});
    }

    startCrop = (file) => {
        const reader = new FileReader();
        reader.addEventListener('load', () =>
            this.setState({src: reader.result})
        );
        reader.readAsDataURL(file);
        this.file = file
        this.setState({elementPhotoDialog: true, imageSrc: file.objectURL})
    };

    cancelCrop = (file) => {
        let crops;
        if (this.state.cropsType === 'logo') {
            crops = {...this.state.cropsLogo};
        }
        Object.keys(crops).forEach(function (key) {
            if (key === file.name) {
                delete crops[key];
            }
        });
        if (this.state.cropsType === 'logo') {
            this.setState({cropsLogo: crops});
        }
    };

    renderFooter = () => {
        return (
            <>
                <Button type="button" loading={this.state.loadingDialog} label={I18n.t('CANCEL')}
                        icon="pi pi-times" className="p-button-text p-button-help"
                        onClick={this.hideDialog}/>
                <Button type="submit" loading={this.state.loadingDialog} label={I18n.t('SAVE')}
                        icon="pi pi-check" className="p-button-text"
                        onClick={() => this.formikRef.current?.submitForm()}
                />
            </>
        );
    }

    render() {
        return (
            <div className="crud-demo">
                <Toast ref={(el) => this.toast = el}/>

                <Dialog visible={this.state.elementDialog} style={{width: '550px'}} modal footer={this.renderFooter()}
                        className="p-fluid" closable={false} onHide={this.hideDialog}
                        header={I18n.t('BUSINESS_CREATION')}>
                    <Formik {...this.formikProps} innerRef={this.formikRef}>
                        {props => {
                            return <form onKeyDown={(event) => event.keyCode === 13 && event.preventDefault()}
                                         className="p-fluid">
                                <div className="p-float-label p-field" style={{marginTop: '10px'}}>
                                    <InputText
                                        autoFocus
                                        name="name"
                                        value={props.values.name}
                                        onChange={props.handleChange}
                                        id="name"
                                        className={classNames({'p-invalid': isFormFieldInvalid(props, 'name')})}
                                    />
                                    {getFormErrorMessage(props, 'name')}
                                    <label htmlFor="name"
                                           className={classNames({'p-error': isFormFieldInvalid(props, 'name')})}>{I18n.t('BUSINESS_NAME')}*</label>
                                </div>

                                <div className="p-float-label p-field" style={{marginTop: '10px'}}>
                                    <InputTextarea
                                        rows={2}
                                        autoResize
                                        name="description"
                                        value={props.values.description}
                                        onChange={props.handleChange}
                                        id="description"
                                        className={classNames({'p-invalid': isFormFieldInvalid(props, 'description')})}
                                    />
                                    {getFormErrorMessage(props, 'description')}
                                    <label htmlFor="description"
                                           className={classNames({'p-error': isFormFieldInvalid(props, 'description')})}>{I18n.t('BUSINESS_DESCRIPTION')}</label>
                                </div>

                                {this.types.length > 1 && <div className="p-fluid p-grid p-formgrid">
                                    <div className="p-field p-col-12">
                                        <span className="p-float-label">
                                             <Dropdown
                                                 name="type"
                                                 id="type"
                                                 value={props.values.type}
                                                 onChange={props.handleChange}
                                                 options={this.types}
                                                 optionLabel="name"
                                                 optionValue="code"
                                                 className={classNames({'p-invalid': isFormFieldInvalid(props, 'type')})}
                                             />
                                            <label htmlFor="type"
                                                   className={classNames({'p-error': isFormFieldInvalid(props, 'type')})}>{I18n.t('CHOOSE_YOUR_BUSINESS_TYPE')}*</label>
                                        </span>
                                        {getFormErrorMessage(props, 'type')}
                                    </div>
                                </div>}

                                <div className="p-fluid p-grid p-formgrid">
                                    <div className="p-field p-col-12">
                                        <span className="p-float-label">
                                             <Dropdown
                                                 name="currencyCode"
                                                 id="currencyCode"
                                                 value={props.values.currencyCode}
                                                 onChange={props.handleChange}
                                                 options={this.currencies}
                                                 optionLabel="name"
                                                 optionValue="code"
                                                 className={classNames({'p-invalid': isFormFieldInvalid(props, 'currencyCode')})}
                                             />
                                            <label htmlFor="currencyCode"
                                                   className={classNames({'p-error': isFormFieldInvalid(props, 'currencyCode')})}>{I18n.t('CHOOSE_PRIMARY_CURRENCY')}*</label>
                                        </span>
                                        {getFormErrorMessage(props, 'currencyCode')}
                                    </div>
                                </div>

                                <div className="p-field" style={{marginTop: '10px'}}>
                                    <label htmlFor="address"
                                           className={"p-d-block " + classNames({'p-error': isFormFieldInvalid(props, 'address', 'label')})}>{I18n.t('ADDRESS')}</label>
                                    <GooglePlacesAutocomplete
                                        name="address"
                                        apiKey={this.props.settings.GMAPS_KEY}
                                        apiOptions={{language: 'fr', region: 'fr'}}
                                        autocompletionRequest={{
                                            componentRestrictions: {
                                                country: ['cm', 'fr', 'us'],
                                            }
                                        }}
                                        selectProps={{
                                            onChange: (data) => {
                                                this.handleMapAddressChange(props, data)
                                            },
                                            value: props.values.address,
                                            placeholder: I18n.t('ENTER_CITY_OR_NEIGHBORHOOD'),
                                            styles: {
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: "#222222",
                                                }),
                                                option: (provided) => ({
                                                    ...provided,
                                                    color: "#222222",
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: "#222222",
                                                }),
                                            },
                                        }}
                                    />
                                    {getFormErrorMessage(props, 'address', 'label')}
                                </div>

                                <div className="p-float-label p-field" style={{marginTop: '10px'}}>
                                    <InputTextarea
                                        rows={1}
                                        autoResize
                                        name="addressLine2"
                                        value={props.values.address.addressLine2}
                                        onChange={(event) => props.setFieldValue('address.addressLine2', event.target.value)}
                                        id="addressLine2"
                                    />
                                    <label htmlFor="addressLine2">{I18n.t('ADDITIONAL_ADDRESS')}</label>
                                    <small id="addressLine2"
                                           className="p-d-block">{I18n.t('ADDITIONAL_ADDRESS_PLACEHOLDER')}</small>
                                </div>

                                <div className="p-float-label p-field" style={{marginTop: '10px'}}>
                                    <InputText
                                        name="website"
                                        value={props.values.website}
                                        onChange={props.handleChange}
                                        id="website"
                                        className={classNames({'p-invalid': isFormFieldInvalid(props, 'website')})}
                                    />
                                    {getFormErrorMessage(props, 'website')}
                                    <label htmlFor="website"
                                           className={classNames({'p-error': isFormFieldInvalid(props, 'website')})}>{I18n.t('BUSINESS_WEBSITE')}</label>
                                    <small id="website"
                                           className="p-d-block">{I18n.t('WEBSITE_SAMPLE_PLACEHOLDER')}</small>
                                </div>

                                <div className="p-float-label p-field" style={{marginTop: '10px'}}>
                                    <InputText
                                        name="email"
                                        value={props.values.email.value}
                                        onChange={(event) => props.setFieldValue('email.value', event.target.value)}
                                        id="email"
                                        className={classNames({'p-invalid': isFormFieldInvalid(props, 'email', 'value')})}
                                    />
                                    {getFormErrorMessage(props, 'email', 'value')}
                                    <label htmlFor="email"
                                           className={classNames({'p-error': isFormFieldInvalid(props, 'email', 'value')})}>{I18n.t('BUSINESS_EMAIL')}</label>
                                </div>

                                <div className="p-field" style={{marginTop: '10px'}}>
                                    <PhoneInput
                                        isValid={props.values.phoneNumber.valid}
                                        inputStyle={{width: '100%'}}
                                        country={'cm'}
                                        name="phoneNumber"
                                        key={this.props.locale}
                                        enableSearch={true}
                                        searchPlaceholder={I18n.t('SEARCH_COUNTRY')}
                                        searchNotFound={I18n.t('NO_COUNTRY_FOUND')}
                                        specialLabel={I18n.t('PHONE_NUMBER') + '*'}
                                        placeholder={I18n.t('PHONE_NUMBER')}
                                        localization={getPhoneLang(this.props.locale)}
                                        value={props.values.phoneNumber.formattedNumber}
                                        onChange={(value, country) => props.setFieldValue('phoneNumber', getFormattedPhone(value, country))}
                                    />
                                    {getFormErrorMessage(props, 'phoneNumber', 'formattedNumber')}
                                </div>

                                {!!props.values.tempLogo &&
                                    <img src={props.values.tempLogo.url}
                                         alt={props.values.tempLogo.name}
                                         style={{width: '100%', display: 'block'}}/>}
                                <div className="p-field">
                                    <FileUpload
                                        chooseLabel={props.values.id ? I18n.t('CHANGE_LOGO_PHOTO') : I18n.t('CHOOSE_LOGO_PHOTO')}
                                        uploadLabel={I18n.t('UPLOAD')} cancelLabel={I18n.t('CANCEL')}
                                        name="logo"
                                        customUpload
                                        disabled={!!props.values.logo}
                                        onSelect={(event) => {
                                            props.setFieldValue('logo', event.files[0])
                                            this.startCrop(event.files[0])
                                        }}
                                        onClear={() => props.setFieldValue('logo', null)}
                                        onRemove={(event) => {
                                            props.setFieldValue('logo', null)
                                            this.cancelCrop(event.file)
                                        }}
                                        accept="image/*" maxFileSize={100000000}
                                        className={classNames({'p-invalid': isFormFieldInvalid(props, 'logo')})}
                                    />
                                    {getFormErrorMessage(props, 'logo')}
                                </div>
                                <div className="p-dialog-footer p-p-0">
                                </div>
                            </form>
                        }
                        }
                    </Formik>
                </Dialog>

                <Dialog id="core-image-crop" visible={this.state.elementPhotoDialog} style={{width: '550px'}}
                        header={I18n.t('PHOTO_PROCESSING')} modal
                        className="p-fluid v-genre" closable={false}
                        onHide={() => this.setState({elementPhotoDialog: false})}>

                    {this.state.imageSrc && this.state.crop && this.state.zoom && this.state.aspect &&
                        <ImageCrop imageSrc={this.state.imageSrc}
                                   crop={this.state.crop}
                                   zoom={this.state.zoom}
                                   aspect={this.state.aspect}
                                   onCropComplete={this.onCropComplete}
                        />}
                    <div className="p-dialog-footer">
                        <Button type="button" loading={this.state.loadingProcessingDialog}
                                label={I18n.t('CANCEL')}
                                icon="pi pi-times" className="p-button-text p-button-help"
                                onClick={this.cancelPhotoCrop}/>
                        <Button type="submit" loading={this.state.loadingProcessingDialog}
                                label={I18n.t('SAVE')}
                                icon="pi pi-check" className="p-button-text"
                                onClick={() => this.setState({elementPhotoDialog: false})}/>
                    </div>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const locale = state.i18n.locale;
    const settings = state.settings;
    const permissions = state.auth.account?.data.permissions;
    return {
        locale,
        settings,
        permissions
    };
}

export default connect(mapStateToProps)(ManageBusiness);


